<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div v-if="useCover" class="cover"></div>
    <div class="container-square">
      <svg
        id="bg-wheel"
        class="container-svg child-center"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 730 730"
      >
        <g>
          <circle :style="{ fill: colorFrame }" cx="365" cy="365" r="347.6" />
        </g>
      </svg>
      <div
        v-if="listSector.length > 0 && this.havePercent"
        class="container-sector child-center"
      >
        <div ref="wheel" class="sub-container-sector">
          <div
            class="sector"
            v-for="(item, index) in listSector"
            :key="index"
            :style="{
              width: listSector.length == 1 ? '100%' : '50%',
              backgroundColor: getBgColor(item, index),
              clipPath:
                listSector.length <= 2
                  ? ''
                  : 'polygon(0% 0%, 100% 50%, 0% 100%)',
              aspectRatio:
                listSector.length <= 2
                  ? '1 / 3'
                  : `1 / calc(2 * tan(180deg / ${listSector.length}))`,
              rotate: `calc(360deg / ${listSector.length} * calc(${
                index + 1
              } - 1))`,
            }"
          >
            <div
              class="d-flex align-center"
              style="height: 100%"
              :style="{ width: listSector.length == 1 ? '50%' : '100%' }"
            >
              <img
                v-if="item.image"
                :src="item.image"
                style="width: 100%; max-width: 50%"
              />
              <div
                v-if="
                  !['', null, undefined].includes(item.name) && !item.hideText
                "
                class="ml-2 text-dot"
                :style="{
                  fontSize: item.fontSize ? item.fontSize + 'px' : '16px',
                  color: item.fontColor
                    ? item.fontColor
                    : getFontColorBasedOnBg(getBgColor(item, index), 'bw'),
                }"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <svg
        id="cover-wheel"
        class="container-svg child-center"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 730 730"
      >
        <g id="shadow" opacity="0.15">
          <path
            d="M46.9,372.5c0-181.7,147.4-329,329.1-329A327.3,327.3,0,0,1,556.3,97.2,327.3,327.3,0,0,0,365,35.9C183.3,35.9,35.9,183.3,35.9,365c0,115.2,59.2,216.5,148.8,275.3C101.3,580.6,46.9,482.9,46.9,372.5Z"
            transform="translate(0)"
          />
        </g>
        <g id="middle">
          <g>
            <g id="shadow-1" opacity="0.2">
              <circle cx="368.5" cy="368.5" r="54.5" />
            </g>
            <g>
              <circle
                cx="365"
                cy="365"
                r="54.5"
                :style="{ fill: colorMiddle }"
              />
            </g>
            <circle id="middle-3" cx="365" cy="365" r="11.6" fill="#ccc" />
          </g>
        </g>
        <g
          :style="{
            transform: rotateIndicator,
            transformOrigin: `center`,
          }"
        >
          <g
            ref="indicator"
            class="indicator"
            :style="{
              transform: indicatorScale,
            }"
          >
            <path
              d="M707,160.5c-11.4-17.9-35.8-22.8-54.5-11a41.7,41.7,0,0,0-13.6,14.1l-33.6,58.9a2.3,2.3,0,0,0,0,2.4,2.4,2.4,0,0,0,2.3,1.1l67.5-5.1a43.8,43.8,0,0,0,18.6-6.3C712.4,202.7,718.3,178.5,707,160.5Z"
              transform="translate(0)"
              fill-opacity="0.22"
            />
            <path
              :style="{ fill: colorPointer }"
              d="M711.9,157.4a38.4,38.4,0,0,0-66,1.8l-31.5,57.5a2.1,2.1,0,0,0,0,2.4,2.6,2.6,0,0,0,2.2,1.2l65.6-3.9a39.6,39.6,0,0,0,17.9-5.9A38.5,38.5,0,0,0,711.9,157.4Z"
              transform="translate(0)"
            />
            <path
              d="M681.7,166.9a9.3,9.3,0,0,0-6.6,4.8l-.8,2.1a14.9,14.9,0,0,0-.2,2.1,8.8,8.8,0,0,0,1.1,4.2,9.2,9.2,0,0,0,2.9,3,7.6,7.6,0,0,0,2.9,1.3l1.1.2a8.6,8.6,0,0,0,4.2-.6,8.4,8.4,0,0,0,3.4-2.5,7.4,7.4,0,0,0,2-3.8,8.5,8.5,0,0,0-.1-4.2,8.4,8.4,0,0,0-2.1-3.8,7.4,7.4,0,0,0-3.5-2.3l-1-.3A12.2,12.2,0,0,0,681.7,166.9Z"
              transform="translate(0)"
              fill="#ccc"
            />
          </g>
        </g>
      </svg>
      <div
        v-if="listSector.length > 0 && this.havePercent"
        class="container-button d-flex justify-center align-center"
      >
        <div
          v-if="showSpinBtn"
          class="button-box d-flex justify-center align-center"
          :style="{
            color: colorSpinBtn,
            backgroundColor: bgColorSpinBtn,
            fontSize: `${textSizeSpinBtn}px`,
          }"
          @click="handleClick"
        >
          {{ textSpinBtn }}
        </div>
      </div>
      <div
        v-if="listSector.length == 0 || !this.havePercent"
        class="container-out-of-stock d-flex justify-center align-center"
      >
        <div
          class="button-box d-flex justify-center align-center"
          style="color: #000000; transform: rotate(0) !important"
          @click="handleClick"
        >
          Out of stock.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFontColorBasedOnBg } from "@/config/general-function";

export default {
  emits: ["onEnd", "onGetItemResult", "onClickSpin"],
  props: {
    listItem: { default: () => [] },
    showSpinBtn: { default: true },
    textSpinBtn: { default: "" },
    textSizeSpinBtn: { default: 14 },
    colorSpinBtn: { default: "#000000" },
    bgColorSpinBtn: { default: "#ffffff" },
    colorFrame: { default: "#ffffff" },
    colorPointer: { default: "#ffffff" },
    colorMiddle: { default: "#ffffff" },
    actionSpinWheel: { default: false },
    useCover: { default: false },
    resultIndex: { default: null },
    funcGetResultGame: { default: null },
    disableClickBtnSpin: { default: false },
  },
  data: () => ({
    listSector: [],
    havePercent: true,
    rotation: 0,
    lastRotation: 0,
    isSpinning: false,
    indicatorAngle: 90,
    indicatorScale: `scale(0.7)`,
    finalIndex: -1,
    finalAngle: null,
    resultIndex_: null,
  }),
  created() {},
  computed: {
    rotateIndicator() {
      const deg = 360 - (this.indicatorAngle - (30 + 1));
      return `rotate(${deg}deg)`;
    },
  },
  methods: {
    handleClick() {
      if (this.listSector.length == 0 || !this.havePercent) return;
      if (!this.isSpinning) {
        this.$emit("onClickSpin");
      }
      if (this.disableClickBtnSpin) return;
      this.spinWheel();
    },
    getRandomInt(min, max) {
      // percent ยังไม่ได้ทำ
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getRandomAngle(list) {
      const sectorCount = list.length;
      const sliceAngle = 360 / sectorCount;
      const firstDeg = 180 + sliceAngle / 2;

      let probabilityMap = [
        { range: [1, 30], probability: 100 },
        { range: [31, 60], probability: 0 },
        { range: [61, 120], probability: 0 },
        { range: [121, 180], probability: 0 },
        { range: [181, 240], probability: 0 },
        { range: [241, 300], probability: 0 },
        { range: [301, 360], probability: 0 },
      ];
      probabilityMap = [];
      let sum = 0;
      for (let [index, item] of list.entries()) {
        const offset = 0.0001;
        let end =
          index == 0
            ? firstDeg - offset
            : probabilityMap[index - 1].range[0] - offset;
        if (end < 0) {
          end += 360;
        }
        let start = end + offset - sliceAngle;
        if (start < 0) {
          start += 360;
        }
        let detail = {
          range: [Number(start.toFixed(4)), Number(end.toFixed(4))],
          probability: item.percent,
          index: index,
        };
        if (detail.probability) {
          let probability = Number(detail.probability);
          if (isNaN(probability) || probability < 0) {
            probability = 0;
          }
          sum = sum + probability;
          detail.probability = probability;
        }
        probabilityMap.push(detail);
      }
      // ========== ========== Analyze Percent ========== ==========
      let indexNull = [];
      let countNull = 0;
      let indexZero = [];
      let countZero = 0;
      for (let i = 0; i < probabilityMap.length; i++) {
        if (probabilityMap[i].probability == 0) {
          indexZero.push(i);
          countZero++;
        } else if ([null, undefined].includes(probabilityMap[i].probability)) {
          indexNull.push(i);
          countNull++;
        }
      }
      if (sum <= 100) {
        if (countZero == sectorCount || countNull == sectorCount) {
          // Ex. [null,null] || [0%,0%] => [50%,50%]
          probabilityMap = probabilityMap.map((x) => {
            x.probability = Math.round(100 / sectorCount);
            return x;
          });
        } else if (countNull == 0) {
          // Ex. [30%,30%,0%] => [50%,50%,0%]
          probabilityMap = probabilityMap.map((x) => {
            x.probability = Math.round((x.probability * 100) / sum);
            return x;
          });
        } else if (countNull != 0) {
          // Ex. [30%,0%,null] => [30%,0%,70%]
          const diff = (100 - sum) / countNull;
          probabilityMap = probabilityMap.map((x) => {
            if ([null, undefined].includes(x.probability)) {
              x.probability = Math.round(diff);
            }
            return x;
          });
        }
      } else if (sum > 100) {
        // Ex. [70%,40%,null] => [64%,36%,0%]
        probabilityMap = probabilityMap.map((x) => {
          if (!x.probability) {
            x.probability = 0;
          }
          x.probability = Math.round((x.probability * 100) / sum);
          return x;
        });
      }
      // ========== ========== ========== ==========

      // ✅ สร้าง List ขององศาตามเปอร์เซ็นต์
      const weightedList = [];

      probabilityMap.forEach(({ range, probability }, index) => {
        let [min, max] = range;

        if (min > max) {
          // ✅ กรณีช่วงข้าม 0 องศา เช่น 270° - 89°
          for (let i = min; i < 360; i++) {
            for (let j = 0; j < probability; j++) {
              if (
                [null, undefined].includes(this.resultIndex_) ||
                (![null, undefined].includes(this.resultIndex_) &&
                  this.resultIndex_ == index)
              ) {
                weightedList.push(i);
              }
            }
          }
          for (let i = 0; i <= max; i++) {
            for (let j = 0; j < probability; j++) {
              if (
                [null, undefined].includes(this.resultIndex_) ||
                (![null, undefined].includes(this.resultIndex_) &&
                  this.resultIndex_ == index)
              ) {
                weightedList.push(i);
              }
            }
          }
        } else {
          // ✅ กรณีปกติ
          for (let i = min; i <= max; i++) {
            for (let j = 0; j < probability; j++) {
              if (
                [null, undefined].includes(this.resultIndex_) ||
                (![null, undefined].includes(this.resultIndex_) &&
                  this.resultIndex_ == index)
              ) {
                weightedList.push(i);
              }
            }
          }
        }
      });

      // ✅ สุ่มองศาจาก weightedList
      let _resultIndex = null;
      const randomIndex = Math.floor(Math.random() * weightedList.length);
      let weighted = weightedList[randomIndex];
      for (let item of probabilityMap) {
        let [min, max] = item.range;
        let start = min;
        let stop = max;
        let checkMinAfterMax = false;
        if (min > max) {
          checkMinAfterMax = true;
        }
        if (!checkMinAfterMax) {
          if (weighted >= start && weighted <= stop) {
            _resultIndex = item.index;
          }
        } else {
          if (
            (weighted >= start && weighted <= 360) ||
            (weighted <= stop && weighted >= 0)
          ) {
            _resultIndex = item.index;
          }
        }
      }
      // ========== ========== Check Angle Diff ========== ==========
      const modelProbabilityMap = probabilityMap[_resultIndex];
      const diffBottom = Math.abs(weighted - modelProbabilityMap.range[0]);
      const diffTop = Math.abs(modelProbabilityMap.range[1] - weighted);
      if (!(diffBottom == 1 && diffTop == 1)) {
        // ไม่เข้า if ถ้า diff เป็น 1 ทั้งคู่ อาจทำให้เกิด error
        if (diffBottom <= 1) {
          weighted += 1;
          if (weighted == 361) {
            weighted = 1;
          }
        } else if (diffTop <= 1) {
          weighted -= 1;
          if (weighted == -1) {
            weighted = 359;
          }
        }
      }
      return {
        angle: weighted,
        index: _resultIndex,
      };
    },
    getFinalSpinAngle() {
      const baseRotation = this.getRandomInt(4, 6) * 360; // หมุน 4-6 รอบ
      const { index, angle } = this.getRandomAngle(this.listSector); // หยุดที่องศาที่สุ่มตามเปอร์เซ็นต์
      const lastWheelDeg = baseRotation + angle - this.indicatorAngle;
      this.finalIndex = index;
      this.finalAngle = lastWheelDeg;
      return this.finalAngle;
    },
    async getResultIndex() {
      try {
        if (this.funcGetResultGame) {
          const item_id = await this.funcGetResultGame();
          if (item_id) {
            this.resultIndex_ = this.listSector.findIndex(
              (x) => x.id == item_id
            );
          }
        }
      } catch (err) {
        console.log("", err);
      }
    },
    async spinWheel() {
      if (this.isSpinning) return;
      this.isSpinning = true;
      await this.getResultIndex();

      //   const targetRotation = this.getRandomInt(720, 1440); // หมุน 2-4 รอบ
      const targetRotation = this.getFinalSpinAngle();
      this.getItemResult();
      const startTime = performance.now();
      const duration = 5000; // หมุน 5 วินาที
      const wheel = this.$refs.wheel;
      const indicator = this.$refs.indicator;
      indicator.style.transform = `rotate(0deg) ${this.indicatorScale}`;

      const sectorCount = this.listSector.length;
      const sliceAngle = 360 / sectorCount;
      const degBetween = 180 + sliceAngle / 2 - this.indicatorAngle;
      const firstSector = degBetween / sliceAngle;
      const decimalPart = firstSector % 1;
      const offset = sliceAngle - sliceAngle * decimalPart; // ✅ บวก Offset ให้ Indicator เช็คจากขอบ

      const animate = (time) => {
        let stopAnimate = false;
        let progress = (time - startTime) / duration;
        const easedProgress = 1 - Math.pow(2, -10 * progress);
        let newRotation = easedProgress * targetRotation;
        const diffRotate = targetRotation - newRotation;
        if (diffRotate < 0.15) stopAnimate = true;

        if (stopAnimate) {
          newRotation = targetRotation;
        }
        wheel.style.transform = `rotate(${newRotation}deg)`;

        const currentDeg = parseFloat(
          wheel.style.transform.match(/-?\d+(\.\d+)?/)[0]
        );
        const adjustedDeg = (currentDeg + offset) % 360; // ✅ ปรับให้เริ่มจากขอบ

        const modRotation = adjustedDeg % sliceAngle;
        const tolerance = adjustedDeg - this.lastRotation;

        if (Math.abs(modRotation) < Math.abs(tolerance)) {
          if (this.listSector.length != 1) {
            indicator.style.transform = `rotate(-10deg) ${this.indicatorScale}`;
            setTimeout(() => {
              indicator.style.transform = `rotate(0deg) ${this.indicatorScale}`;
            }, 130);
          }
        }

        this.lastRotation = adjustedDeg;

        if (!stopAnimate) {
          requestAnimationFrame(animate);
        } else {
          this.isSpinning = false;
          this.getFinalSector();
        }
      };

      requestAnimationFrame(animate);
    },
    getFinalSector() {
      let finalSector = this.listSector[this.finalIndex];
      this.$emit("onEnd", {
        list: this.listSector,
        model: finalSector,
        index: this.finalIndex,
        angle: this.finalAngle,
      });
      return finalSector;
    },
    getItemResult() {
      let finalSector = this.listSector[this.finalIndex];
      let result = {
        list: this.listSector,
        model: finalSector,
        index: this.finalIndex,
        angle: this.finalAngle,
      };
      this.$emit("onGetItemResult", result);
    },
    getFontColorBasedOnBg(color, mode) {
      const res = getFontColorBasedOnBg(color, mode);
      return res;
    },
    getBgColor(item, index) {
      const color = item.bgColor
        ? item.bgColor
        : index % 2 == 0
        ? "#FAFAFA"
        : "#EEEEEE";
      return color;
    },
  },
  watch: {
    listItem: {
      handler() {
        this.listSector = [];
        if (Array.isArray(this.listItem)) {
          const list = this.listItem.filter((x) => x.status != "inactive");
          this.listSector = [...list];
          const checkPercent = this.listSector.filter((x) => x.percent == 0);
          this.havePercent = true;
          if (checkPercent.length == this.listSector.length) {
            this.havePercent = false;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    actionSpinWheel: {
      handler() {
        if (this.actionSpinWheel) {
          this.spinWheel();
        }
      },
      deep: true,
      immediate: true,
    },
    resultIndex: {
      handler() {
        this.resultIndex_ = this.resultIndex;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.cover {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background-color: #ffffff00;
}

.container-square {
  width: 100%;
  aspect-ratio: 1 / 1.1;
  position: relative;
  overflow: hidden;
}

.container-sector {
  background-color: #ffffff;
  width: 90%;
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  clip-path: inset(0 0 0 0 round 50%);
}

.child-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.container-svg {
  width: 100%;
  height: 100%;
}

.container-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 15%;
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.button-box {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.container-out-of-stock {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 200px;
  padding: 8px;
  border-radius: 8px;
  border: solid 1px #000000;
  background-color: #ffffffcc;
  font-size: 24px;
  overflow: hidden;
  z-index: 2;
}

.sub-container-sector {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.sector {
  position: absolute;
  /* width: 50%; */
  /* clip-path: polygon(0% 0%, 100% 50%, 0% 100%); */
  transform-origin: center right;
  padding: 2% 8% 2% 4%;
}

.indicator {
  transform-box: fill-box;
  transform-origin: center;
  transition: transform 0.13s ease-out;
}

.text-dot {
  overflow: hidden;
  /* white-space: nowrap; */
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
</style>
